import { render, staticRenderFns } from "./edit_product_group.vue?vue&type=template&id=019a6d44&scoped=true&"
import script from "./edit_product_group.vue?vue&type=script&lang=js&"
export * from "./edit_product_group.vue?vue&type=script&lang=js&"
import style0 from "./edit_product_group.vue?vue&type=style&index=0&id=019a6d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a6d44",
  null
  
)

export default component.exports